import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDropdownField } from '../dropdown-field-box/model/IDropdown';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-filter-box',
  templateUrl: './filter-box.component.html',
  styleUrls: ['./filter-box.component.scss']
})
export class FilterBoxComponent implements OnInit {
  @Input() isFilterShow: any;
  @Input() listOfFilter: any;
  @Output() onHideEvent = new EventEmitter<boolean>();
  @Output() onFilterApply = new EventEmitter<any[]>();
  @Output() onFilterClear = new EventEmitter<any[]>()
  @Output() outputKeyword = new EventEmitter<any[]>()
  @Output() searchKeyword = new EventEmitter<IDropdownField>()

  constructor(private datepipe: DatePipe) { }

  ngOnInit() {
  }

  onHideEventFn() {
    this.onHideEvent.emit(false);
  }

  onDropdownSelect(selectedItem: any, index: any) {
    if (typeof (selectedItem) === "object") {
      if (this.listOfFilter[index].type == "date") {
        this.listOfFilter[index].value = this.datepipe.transform(selectedItem, "yyyy-MM-dd");
      } else {
        if (this.listOfFilter[index].isValueBind == true) {
          this.listOfFilter[index].value = selectedItem.value;
        } else {
          this.listOfFilter[index].value = selectedItem.name;
        }
      }
      return;
    }
    this.listOfFilter[index].value = selectedItem;
  }

  onApplyFilter() {
    this.onHideEventFn();
    this.onFilterApply.emit(this.listOfFilter);
  }

  onclearFilter() {
    this.onHideEventFn();
    // const listOfFilter = [...this.listOfFilter]
    // listOfFilter.map(x => {
    //   x.value = null;
    // });
    // this.listOfFilter = listOfFilter;
    
    const listOfFilter = [...this.listOfFilter]
    listOfFilter.forEach(filter => {
      filter.value = null;
      if (filter.checkboxGroupOptions) {
        filter.checkboxGroupOptions.forEach(option => {
          option.checked = false; 
        });
      }
    });
    this.onFilterClear.emit(this.listOfFilter);
  }

  onSearch = (event: string, index: string | number): void => {
    this.listOfFilter[index].searchKeyword = event;
    this.searchKeyword.emit(this.listOfFilter[index]);
  }

  onCheckboxGroupChange(item: any, option: { label: string, value: string, checked: boolean }) {
    console.log(`Checkbox group option ${option.value} changed to ${option.checked}`);
    if (option.checked) {
      item.value.push(option.value);
    } else {
      item.value = item.value.filter((val: string) => val !== option.value);
    }
  }


}
